module.exports = __webpack_public_path__ + "static/media/factory-image.bdd93692.png";